import { IDs } from '../../helpers/IDs';

export function isValid(key: string, data: any, dataGlobal: any, callback?: (data: any) => void): boolean {
    data = data || {};
    dataGlobal = dataGlobal || {};
    // const compare_error: number = 0.5;
    const compare_warning: number = 0.5;
    const jahr: number = +data.jahr || null;
    const standort_tid: number = +data.standort_tid_orig || +data.standort_tid || 0;
    const kennzahlen: any = (dataGlobal[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort_tid]
        || dataGlobal[IDs.KENNZIFFERN_BERECHNET] || {};
    const value: number = +(kennzahlen[jahr] || {})[key] || 0;
    const compare: number[] = [value];
    const values: any[] = [
        { jahr: +jahr - 1, value: +(kennzahlen[+jahr - 1] || {})[key] || 0 },
        { jahr: +jahr + 1, value: +(kennzahlen[+jahr + 1] || {})[key] || 0 }
    ];
    let index: number = null;
    let isGreater: boolean = false;
    let isLess: boolean = false;
    let isValid: boolean = true;
    let percent: number;

    if (value <= 0 || (values[0] <= 0 && values[1] <= 0)) {
        if (typeof callback === 'function') {
            callback({ isGreater, isLess, jahr: null });
        }
        return true;
    }

    values.forEach((item: any, i: number) => {
        const curValue: number = item.value || 0;

        switch (true) {
            case (curValue <= 0 || index !== null):
                break;
            // case (value < (curValue - (compare_error * curValue))):
            //     isLess = true;
            //     isValid = false;
            //     percent = -(1 - (value / curValue)) * 100;
            //     break;
            // case (value > (curValue + (compare_error * curValue))):
            //     isGreater = true;
            //     isValid = false;
            //     percent = (value / curValue) * 100;
            //     break;
            case (value < (curValue - (compare_warning * curValue))):
                isLess = true;
                percent = -(1 - (value / curValue)) * 100;
                break;
            case (value > (curValue + (compare_warning * curValue))):
                isGreater = true;
                percent = (value / curValue) * 100;
                break;
            default:
                index = i;
                break;
        }
        index = (index === null && (isLess || isGreater)) ? i : index;

        if (compare.length < 2 && (isLess || isGreater)) {
            compare.push(curValue);
        }
    });

    if (typeof callback === 'function') {
        callback({ compare, isGreater, isLess, isValid, jahr: (isLess || isGreater) ? values[index].jahr : null, percent });
    }

    return isValid;
}
